import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../../slatePlugins/slatePlugins.types';
import {
  ELEMENT_IMAGE_SLIDE_TEXT,
  ELEMENT_IMAGE_SLIDE_TEXT_INPUT,
  ImageSlideTextPluginOptions,
} from './ImageSlideTextPlugin.types';

const ImageSlideShowControlEditElementReadOnly = dynamicEditorComponent(() =>
  import(
    /* webpackExports: "ImageSlideShowControlEditElementReadOnly" */ '../SlideShow/components/ImageSlideShowControlEditElementReadOnly'
  ).then((mod) => mod.ImageSlideShowControlEditElementReadOnly)
);
const ImageSlideTextInputElementReadOnly = dynamicEditorComponent(
  () =>
    import(
      /* webpackExports: "ImageSlideTextInputElementReadOnly" */ './components/ImageSlideTextInputElement'
    ).then((mod) => mod.ImageSlideTextInputElementReadOnly),
  {
    dependsOn: ImageSlideShowControlEditElementReadOnly,
  }
);

export const ImageSlideTextReadOnlyPlugin = (
  options?: ImageSlideTextPluginOptions
): SlatePlugin => ({
  renderElement: (renderProps: RenderElementProps) => {
    const { element } = renderProps;

    if (element?.type === ELEMENT_IMAGE_SLIDE_TEXT) {
      return <ImageSlideShowControlEditElementReadOnly {...renderProps} {...options} />;
    }

    if (element?.type === ELEMENT_IMAGE_SLIDE_TEXT_INPUT) {
      return <ImageSlideTextInputElementReadOnly {...renderProps} {...options} />;
    }
    return undefined;
  },
});
